import { render, staticRenderFns } from "./ClassifyTree.vue?vue&type=template&id=0fdf43fe&scoped=true&"
import script from "./ClassifyTree.vue?vue&type=script&lang=js&"
export * from "./ClassifyTree.vue?vue&type=script&lang=js&"
import style0 from "./ClassifyTree.vue?vue&type=style&index=0&id=0fdf43fe&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fdf43fe",
  null
  
)

export default component.exports